/* GLP-1 LP: scroll reveals + sticky cart bar that waits until the hero has scrolled away. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function watch(selector, onEnter, opts) {
    var els = typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(onEnter); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); onEnter(e.target); }
      });
    }, opts || { threshold: 0.35 });
    els.forEach(function (el) { io.observe(el); });
  }
  function sticky() {
    var bar = document.querySelector('.ke-sticky');
    var hero = document.getElementById('top');
    if (!bar || !hero || !('IntersectionObserver' in window) || bar.dataset.keWatch) return;
    bar.dataset.keWatch = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('ke-sticky--hide', e.isIntersecting); });
    }, { threshold: 0 }).observe(hero);
  }
  function init() {
    sticky();
    if (reduce) return;
    document.querySelectorAll('.c-glp-reveal:not(.is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('is-pending');
    });
    watch('.c-glp-reveal.is-pending', function (el) { el.classList.remove('is-pending'); el.classList.add('is-in'); }, { threshold: 0.15 });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
